import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combine conditional class names.
 *
 * Usage:
 *   cn('base-class', condition && 'conditional', { active: isActive })
 *
 * Uses tailwind-merge to resolve conflicts (e.g. `px-4` and `px-6` → `px-6`).
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
